import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { WhatsappLogo, ArrowRight, Globe } from "@phosphor-icons/react";
import { api, isConsult, waLink } from "../lib/api";

const WA = waLink("¡Hola Ciudad Garaje! Quiero conocer los precios de las cervezas importadas 🍺");

export const ImportadasShowcase = () => {
  const [beers, setBeers] = useState([]);

  useEffect(() => {
    api.get("/beers").then(({ data }) => setBeers(data.filter(isConsult)));
  }, []);

  if (!beers.length) return null;

  return (
    <section className="bg-[#0d0d0d] border-y border-white/10 py-14 md:py-20" data-testid="importadas-showcase">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-8">
          <div>
            <div className="overline text-[#F5A623] mb-2 flex items-center gap-2"><Globe size={14} weight="bold" /> Cervezas importadas</div>
            <h2 className="font-display text-4xl md:text-6xl leading-none text-white">{beers.length} cervezas del mundo</h2>
            <p className="text-gray-400 text-sm md:text-base mt-3 max-w-xl">De Bélgica, Alemania, Irlanda, España, EE.UU., Australia y Colombia. Los precios cambian según la llegada de cada lote: pregúntanos por WhatsApp.</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <a href={WA} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#25D366] hover:bg-[#1ebe5b] text-black font-semibold uppercase tracking-wider text-sm transition-colors" data-testid="importadas-whatsapp">
              <WhatsappLogo size={20} weight="fill" /> Consultar precios
            </a>
            <Link to="/catalogo?cat=importada" className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-white/20 hover:border-[#D97736] text-white uppercase tracking-wider text-sm transition-colors" data-testid="importadas-ver-todas">
              Ver todas <ArrowRight size={16} weight="bold" />
            </Link>
          </div>
        </div>
        <div className="flex gap-4 overflow-x-auto cg-scroll pb-3 snap-x" data-testid="importadas-strip">
          {beers.map((b) => (
            <Link key={b.id} to="/catalogo?cat=importada" className="group snap-start shrink-0 w-[150px] md:w-[180px] bg-[#171717] border border-white/10 hover:border-[#D97736]/60 transition-colors" data-testid={`importada-thumb-${b.id}`}>
              <div className="aspect-[3/4] overflow-hidden bg-black">
                <img src={b.image_url} alt={b.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-3">
                <div className="text-[10px] uppercase tracking-widest text-gray-500">{b.origin}</div>
                <div className="font-display text-base leading-tight text-white mt-1 line-clamp-2">{b.name}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
